import("../../../assets/js/splide.js")
	.then(({ Splide, AutoScroll }) => {
		// Variables
		const sliders = document.querySelectorAll(".logos-slider .splide")

		// Initializing Splider
		for (let i = 0; i < sliders.length; i++) {
			new Splide(sliders[i], {
				type: "loop",
				gap: "3rem",
                arrows: false,
				pagination: false,
				//autoWidth: true,
				perPage: 5,
				autoScroll: {
					speed: .75
				},
                breakpoints: {
                    767: {
                        gap: "2.5rem",
                    },
                },
				autoScroll: {
					pauseOnHover: false,
					pauseOnFocus: false
				}
			}).mount({ AutoScroll });
		}
	})
	.catch((err) => {
		console.error(err);
	});